export default "__VITE_ASSET__OfQqglVi__"